import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { RefreshCw, X } from 'lucide-react';
import { usePWA } from '@/hooks/usePWA';

export function PWAUpdatePrompt() {
  const { isUpdateAvailable, updateApp, dismissUpdate } = usePWA();

  if (!isUpdateAvailable) return null;

  return (
    <div className="fixed top-4 left-4 right-4 z-50 md:left-auto md:right-4 md:max-w-sm">
      <Card className="shadow-lg border-primary/20 bg-card/95 backdrop-blur-sm">
        <CardContent className="p-4">
          <div className="flex items-start gap-3">
            <div className="p-2 rounded-full bg-primary/10">
              <RefreshCw className="h-5 w-5 text-primary" />
            </div>
            
            <div className="flex-1 min-w-0">
              <h4 className="font-semibold text-sm mb-1">
                Atualização Disponível
              </h4>
              <p className="text-xs text-muted-foreground mb-3">
                Uma nova versão do AliMenu está disponível
              </p>
              
              <div className="flex gap-2">
                <Button 
                  size="sm" 
                  variant="default" 
                  onClick={updateApp}
                  className="text-xs h-8"
                >
                  <RefreshCw className="h-3 w-3 mr-1" />
                  Atualizar
                </Button>
                
                <Button 
                  size="sm" 
                  variant="ghost" 
                  onClick={dismissUpdate}
                  className="text-xs h-8 px-2"
                >
                  <X className="h-3 w-3" />
                </Button>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}